import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import "core-js/modules/es.array.push.js";
import { mapGetters } from 'vuex';
import { checkPower } from '@/api/modules/personal.js';
import { fastContract } from '@/api/modules/product.js';
export default {
  name: 'sub-menu',
  props: {
    subMenuList: {
      type: Array,
      required: true
    },
    menuName: {
      type: String
    },
    productMenu: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      visible: false,
      form: this.$form.createForm(this, {
        name: 'dynamic_rule'
      }),
      // plainOptions: [
      //   '问财数据组件',
      //   '大模型工坊',
      //   '智能投资助理',
      //   '智能文档问答',
      //   '智能培训助手',
      //   'AI短视频',
      //   '智能员工助手',
      //   'AI数字人',
      // ],
      editForm: {
        checkValue: [],
        explain: ''
      },
      checkedList: [],
      defaultArr: this.productMenu
    };
  },
  methods: {
    handleClickSubMenu(subMenu) {
      if (this.menuName === '产品试用') {
        if (this.haslogin) {
          this.checkRole(subMenu);
          // this.visible = true;
        } else {
          _message.warning('亲，请先登录哦');
        }
      } else {
        this.$router.push({
          path: subMenu.path
        });
        this.$emit('closeSubMenu');
      }
    },
    checkRole(subMenu) {
      checkPower({
        presentation_code: subMenu.code
      }).then(res => {
        if (res.code === 1) {
          let token = localStorage.getItem('access_token');
          let query = `access_token=${token}`;
          let path = subMenu.path.indexOf('?') !== -1 ? subMenu.path + '&' + query : subMenu.path + '?' + query;
          window.open(path);
          this.$emit('closeSubMenu');
        } else {
          if (res.result.length > 0) {
            res.result.forEach(ol => {
              this.defaultArr.forEach(ol2 => {
                if (ol === ol2.code) {
                  ol2.disabled = true;
                }
              });
            });
          } else {
            this.defaultArr = this.productMenu;
          }
          this.visible = true;
        }
      });
    },
    handleOk() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          const params = {
            product_name: values.checkValue.join(','),
            explain: values.explain,
            source: '官网-产品试用'
          };
          fastContract(params).then(res => {
            if (res.code === 1) {
              _message.success('试用申请已提交，请耐心等待');
              this.visible = false;
            }
          });
        }
      });
    },
    handleCancel() {},
    onChange() {}
  },
  computed: {
    ...mapGetters(['haslogin'])
  }
};